import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class LabelValueComponent extends Vue {
    @Prop({ default: null }) public object: any;
}
